// extracted by mini-css-extract-plugin
export default {"icon":"Icons_icon__5vljy","IconMenu":"Icons_IconMenu__Nes6v","largeIcon":"Icons_largeIcon__gPKhb"};